import { FORMAT_DAY_MONTH_YEAR_HOUR_MIN } from '@form-builder/config'
import { Media } from '@form-builder/types'
import { UploadFile } from 'antd'

import dayjs from 'dayjs'

export const normalizeValues = (values: Media) => {
  const { name, description, file } = values

  if (file) {
    const { uid, response, size, originFileObj, type } = file[0]

    return {
      uid,
      name,
      content_type: response?.content_type,
      url: response?.url,
      description,
      size,
      width: response?.attributes?.width,
      height: response?.attributes?.height,
      originFileObj,
      type
    }
  }

  delete values.modified_at
  delete values.permission
  delete values.status

  return values
}

export const normalizeFile = (file: {
  fileList: UploadFile[]
}): UploadFile[] | null => {
  if (Array.isArray(file)) {
    return file
  }

  return file?.fileList || null
}

export const checkImageURL = (url?: string) => {
  return url?.toLowerCase().match(/\.(jpeg|jpg|gif|png)$/) != null
}

export function normalizeMediaList(mediaList: Media[] = []) {
  return mediaList.map(({ modified_at, ...rest }) => {
    const updatedDate = dayjs(modified_at).isValid()
      ? dayjs(modified_at).format(FORMAT_DAY_MONTH_YEAR_HOUR_MIN)
      : ''

    return {
      modified_at: updatedDate,
      ...rest
    }
  })
}

export const replaceFileExtension = (
  filename: string,
  newExtension?: string,
  isFullName = false
) => {
  const extension = !isFullName ? newExtension : newExtension?.split('.')?.pop()

  if (!extension) return filename

  return filename.replace(/\.[^/.]+$/, '') + '.' + extension.replace(/^\./, '')
}
